/** SSOT page size for marketing changelog infinite scroll. */
export const CHANGELOG_LIST_PAGE_SIZE = 12;
